import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, inputClass } from "@/components/base";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { landingFor } from "@/pages/AuthGoogle";

// REQ-1601: "Vérifie ta boîte mail" with the 6-digit code, spam hint and Renvoyer after 60 s.
export default function CheckInbox({ email, wait = 60, testPrefix = "inbox" }) {
  const [code, setCode] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [left, setLeft] = useState(wait);
  const [sent, setSent] = useState("");
  const navigate = useNavigate();
  const { refresh } = useAuth();
  useEffect(() => {
    if (left <= 0) return undefined;
    const t = setTimeout(() => setLeft((n) => n - 1), 1000);
    return () => clearTimeout(t);
  }, [left]);
  const submit = async (e) => {
    e.preventDefault();
    if (code.length !== 6) return setErr("Entre les 6 chiffres du code.");
    setBusy(true);
    setErr("");
    try {
      await api.post("/auth/code", { email, code });
      const u = await refresh();
      navigate(landingFor(u), { replace: true });
    } catch (e2) {
      setErr(errMsg(e2, "Ce code a expiré ou a déjà servi. Demande un nouveau code."));
    } finally {
      setBusy(false);
    }
  };
  const resend = async () => {
    setErr("");
    setSent("");
    try {
      const r = await api.post("/auth/login", { email });
      setLeft(r.data.resend_in || 60);
      setSent("Nouveau code envoyé.");
    } catch (e2) {
      setErr(errMsg(e2, "L'email n'est pas parti. Réessaie dans un instant."));
    }
  };
  return (
    <form onSubmit={submit} noValidate className="fade-up flex flex-col gap-3" data-testid={`${testPrefix}-screen`}>
      <h2 className="text-[20px] font-semibold tracking-[-0.02em] text-ink">Vérifie ta boîte mail</h2>
      <p className="text-[15px] text-muted" data-testid={`${testPrefix}-sent-to`}>On a envoyé un code à 6 chiffres à <b className="font-medium text-ink">{email}</b>.</p>
      <input
        className={`${inputClass} num text-center text-[24px] tracking-[0.3em]`}
        inputMode="numeric"
        autoComplete="one-time-code"
        maxLength={6}
        placeholder="000000"
        aria-label="Code à 6 chiffres"
        data-testid={`${testPrefix}-code`}
        value={code}
        onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
      />
      {err && <p className="err-msg text-[13px] text-ink" data-testid={`${testPrefix}-error`}>{err}</p>}
      <Button type="submit" disabled={busy} className="w-full" data-testid={`${testPrefix}-submit`}>{busy ? "Vérification..." : "Me connecter"}</Button>
      <p className="text-[13px] text-muted" data-testid={`${testPrefix}-spam`}>Rien reçu ? Regarde dans tes spams ou ton courrier indésirable</p>
      <button type="button" onClick={resend} disabled={left > 0} className="self-start text-[14px] font-medium text-ink underline underline-offset-4 disabled:text-muted disabled:no-underline" data-testid={`${testPrefix}-resend`}>
        {left > 0 ? `Renvoyer (${left} s)` : "Renvoyer"}
      </button>
      {sent && <p className="text-[13px] text-muted" data-testid={`${testPrefix}-resent`}>{sent}</p>}
    </form>
  );
}
